import { preload } from 'react-isomorphic-render';
import { connect } from 'react-redux';
import { contentfulModels } from '@glowforge/ui-common';
import { fetchUserPurchaseHistory } from 'app/api/account-settings-api';
import PurchaseHistory from 'app/components/settings/purchase-history';
import { getPurchaseHistory } from 'app/selectors/user';

const { getStringsForPage } = contentfulModels;

const mapStateToProps = state => ({
  purchaseHistory: getPurchaseHistory(state),
  pageStrings: getStringsForPage(_.get(state, 'accountSettings.settingsPage.fields')),
});

const PurchaseHistoryContainer = connect(mapStateToProps)(preload(
  ({ dispatch }) => Promise.all([
    dispatch(fetchUserPurchaseHistory()),
  ]))(PurchaseHistory),
);

export default PurchaseHistoryContainer;



// WEBPACK FOOTER //
// ./app/containers/settings/purchase-history.js